export default "__VITE_ASSET__D6JQjAZ7__"